<div class="login" style="background-image: url('assets/images/login.png'); background-repeat: no-repeat; background-size: 70% 100%; background-position: center; width: 100%; height: 100vh;padding-right:5% ;">
    <!-- Background Video -->      
    <!-- Login Form Container -->
    <div class="login-container">
      <div class="login-card animate">
        <div class="login-header">
          <div class="logo-container">
            <img src="assets/logo/logokryfs.png" alt="Bola Dashboard Logo" style="width: 120px; height: auto;" />
          </div>
          <h2 class="animate delay-1">BOLA Dashboard</h2>
          <p class="animate delay-1">Access your connected devices</p>
        </div>
        <div class="login-body">
          <form [formGroup]="form" (ngSubmit)="submit()">
            <div class="form-group animate delay-2">
              <i class="fas fa-envelope form-icon"></i>
              <input type="text" class="form-control" placeholder="Your Email Address" formControlName="email" required>
              <span class="form-error" *ngIf="form.controls.email.touched && form.controls.email.errors?.required">
                Please Enter Email Address
              </span>
              <span class="form-error" *ngIf="form.controls.email.touched && form.controls.email.errors?.email">
                Enter Valid Email Address.
              </span>
            </div>
            <div class="form-group animate delay-3">
              <i class="fas fa-lock form-icon"></i>
              <input class="form-control" [type]="hide ? 'password' : 'text'" placeholder="Password" formControlName="pass" required>
              <button type="button" class="password-toggle" (click)="hide = !hide">
                <i class="fas" [ngClass]="hide ? 'fa-eye' : 'fa-eye-slash'"></i>
              </button>
              <span class="form-error" *ngIf="form.controls.pass.touched && form.controls.pass.errors?.required">
                Please Enter Password
              </span>
            </div>
            <div class="forgot-password animate delay-3">
              <a style="cursor: pointer;" (click)="openForgotPasswordComponent()">Forgot password?</a>
            </div>
            <p *ngIf="responseCode === '-1'" class="form-error text-center mt-2">
              {{showMessage}}
            </p>
            <div class="animate delay-4">
              <button type="submit" class="btn-login">
                Sign In
                <mat-progress-bar class="progress-bar" mode={{buttonMode}} value="0"></mat-progress-bar>
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>